export default {
    listagem: {
        titulo_pagina: 'Editable Results',
        table: {
            empty: 'No Vns found',
            nome: 'Vns',
            empresa: 'Company',
            resultado_descartavel: 'Editable Result',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            editar: 'Edit Editable Results'
        },
        fields: {
            vns: {
                label: 'Vns',
                description: 'Vns name'
            },
            report_editable: {
                label: 'Editable Results',
                description: 'Results that will be edited by vns'
            },
            exam: {
                label: 'Exam'
            },
            mnemonic: {
                label: 'Mnemonic'
            },
            action: {
                label: 'Action'
            }
        },
        buttons: {
            adicionar_exame: 'Add Exam',
            remover_exame: 'Remove Exam',
            botao_salvar: 'Save Editable Results'
        },
        update: {
            success: 'Editable results updated successfully!',
            error: 'Error updating editable results!'
        }
    }
}